import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";
import { SpaceAccessLevel } from "types/generated";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";

const FlowsProjectDetailsRolesSpaceCell = ({
  item: roleBinding,
  ...cellProps
}: TableSimpleCellProps<FlowsProjectRoleBindingView>) => {
  const hasAccessToSpace = roleBinding.space.accessLevel !== SpaceAccessLevel.None;

  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath
        spaceId={roleBinding.space.id}
        fallbackName={roleBinding.space.name}
        disabled={!hasAccessToSpace}
        tooltip={!hasAccessToSpace ? "You don't have access to this space" : undefined}
      />
    </TableSimpleCell>
  );
};

export default FlowsProjectDetailsRolesSpaceCell;
